import { render, staticRenderFns } from "./fileCopy.vue?vue&type=template&id=0123ed78&"
import script from "./fileCopy.vue?vue&type=script&lang=js&"
export * from "./fileCopy.vue?vue&type=script&lang=js&"
import style0 from "./fileCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports